import { DataSource, Layout, Map } from "@mcleod/components";

export abstract class AutogenLayoutOrderMapView extends Layout {
    map1: Map;
    sourceCustomerOrderDetail: DataSource;
    sourceOrders: DataSource;
}
